import { __rest } from "tslib";
import React from 'react';
import styles from './FadeIn.module.scss';
const FadeIn = (_a) => {
    var { className, duration = 300, delay = 0, children, style, fromTop, fromBottom, refElement } = _a, props = __rest(_a, ["className", "duration", "delay", "children", "style", "fromTop", "fromBottom", "refElement"]);
    const getAnimationName = () => {
        if (fromTop) {
            return styles.fadeInFromTop;
        }
        if (fromBottom) {
            return styles.fadeInFromBottom;
        }
        return styles.fadeIn;
    };
    const animationStyle = Object.assign({ animationDuration: `${duration}ms`, animationDelay: `${delay}ms`, animationName: getAnimationName() }, style);
    return (React.createElement("div", Object.assign({ style: animationStyle, className: `${styles.container} ${className}`, ref: refElement }, props), children));
};
export default FadeIn;
//# sourceMappingURL=FadeIn.js.map